import { AppThemeData, AppThemeFontProperty, AppThemeIconProperty, GenericAppThemeProperty } from "./Types";

export const getPropertiesByCategory = (
  propertiesList: GenericAppThemeProperty[],
  category: string
): GenericAppThemeProperty[] => {
  if (!Array.isArray(propertiesList)) return [];

  const categoryLower = category.toLowerCase();

  return propertiesList.filter(
    (property) => property.category?.toLowerCase() === categoryLower
  );
};

export const getFilteredFontProperties = (
  fontProperties: AppThemeFontProperty[],
  isDark?: boolean
) => {
  if (!fontProperties) return [];
  
  const fontEntries = Array.isArray(fontProperties) 
    ? fontProperties 
    : [fontProperties];

  if (isDark === undefined) return fontEntries;
  
  return fontEntries.filter((property: any) => property.isDark === isDark);
};

export const getFilteredIconProperties = (
  iconProperties: AppThemeIconProperty[],
  isDark?: boolean
) => {
  if (!iconProperties) return [];
  
  const iconEntries = Array.isArray(iconProperties) 
    ? iconProperties 
    : [iconProperties];

  if (isDark === undefined) return iconEntries;
  
  return iconEntries.filter((property: any) => property.isDark === isDark);
};

export const getKeyValueProperties = (
  propertiesList: AppThemeData,
  category: string
) => {
  const properties = getPropertiesByCategory(propertiesList.genericThemeProperties, category);
  return properties.filter((property: any) => 
    Array.isArray(property) && property.length === 2
  );
};

export const hexToRgba = (hex: string, alpha: number): string => {
  if (!hex) {
    return;
  }
  const parsedHex = hex.replace("#", "");
  const bigint = parseInt(parsedHex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const parseIcon = (iconValue: string): [string, string] => {
  if (!iconValue) return ["fas", "user"];

  // Check for Unicode (starts with "0x")
  if (iconValue.startsWith("0x")) {
    try {
      const codePoint = parseInt(iconValue, 16);
      const unicodeChar = String.fromCodePoint(codePoint);
      return ["fas", unicodeChar]; // keep FontAwesome style, return unicode character as name
    } catch {
      return ["fas", "user"]; // fallback if invalid
    }
  }

  // FontAwesome-style icon
  const [style, iconName] = iconValue.split(":");
  const getIconPrefix = (style: string): string => {
    switch (style) {
      case "solid": return "fas";
      case "regular": return "far";
      case "light": return "fal";
      case "thin": return "fat";
      case "duotone": return "fad";
      case "brands": return "fab";
      default: return "fas";
    }
  };

  return [getIconPrefix(style), iconName || "user"];
};
